import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { IconButton, Tooltip, useTheme } from '@mui/material';
import { JackOLanternIcon, PumpkinIcon } from '@pn/ui/icons';
import { type PNTheme, usePNThemeContext } from '@pn/ui/theme/PNThemeProvider';

const isOctober = () => {
  const now = new Date();
  return now.getMonth() === 9;
};

const { LightIcon, DarkIcon } = (() => {
  if (isOctober()) {
    return {
      LightIcon: () => <PumpkinIcon />,
      DarkIcon: () => <JackOLanternIcon />,
    };
  } else {
    return {
      LightIcon: () => <LightModeIcon />,
      DarkIcon: () => <DarkModeIcon />,
    };
  }
})();

export const LightDarkModeToggleButton = () => {
  const theme = useTheme();
  const { setPNTheme } = usePNThemeContext();

  const handleToggle = () => {
    const newPNTheme: PNTheme =
      theme.palette.mode === 'light' ? 'Stack Dark' : 'Stack Light';
    setPNTheme(newPNTheme);
  };

  return (
    <Tooltip
      title={`Turn ${theme.palette.mode === 'light' ? 'off' : 'on'} the light`}
    >
      <IconButton onClick={handleToggle} size="small">
        {theme.palette.mode === 'light' ? <LightIcon /> : <DarkIcon />}
      </IconButton>
    </Tooltip>
  );
};
